import VForm from "@/vuetify_custom/v-form";
import VTable from "@/vuetify_custom/v-table/v3";
import VModel from "@/vuetify_custom/v-modal_v1";
import { commonValidateRule } from "@/libs/rules_utils.js";
import TextField from "@/vuetify_custom/v-form/components/Text_Field.js";
import { TEXT_FIELD } from "@/vuetify_custom/v-form/type_name";
import {
  getContractDetailApi,
  getThirdPartyMallAvailableStockNumApi,
  getSellSettlementDetailApi,
} from "../services";
import NumberField from "@/vuetify_custom/v-form/components/Number_Field.js";
import { SettlementTypeMap } from "../constants";

const commonValidateRuleT = commonValidateRule("必填");

function createSellSettlementOrderItem() {
  return {
    settlement_type: "adjustment", // 创建默认人工调整
    price: null,
    quantity: null,
    tax_rate: null,
    amount: null,
  };
}

function createParams(params) {
  return {
    id: params?.id || null,
    contract_id: params?.contract_id || null,
    name: params?.name || null,
    payee_company_name: params?.payee_company_name || null,
    payee_company_id: params?.payee_company_id || null,
    begin_date: params?.begin_date || null,
    end_date: params?.end_date || null,
    remark: params?.remark || null,
    sell_settlement_order_items: params?.sell_settlement_order_items || [],
  };
}

function calcAmount(item) {
  if (!item?.price || !item?.quantity || !item?.tax_rate) {
    return 0;
  }
  return math
    .eval(`${item.price} * ${item.quantity} * (1 + ${item.tax_rate})`)
    .toFixed(2);
}

export default {
  data() {
    return {
      dis: false,
      submitLoading: false,
      params: createParams({}),
      resellOrder: createSellSettlementOrderItem(),
      currentContract: null,
      currentContractDetail: null,
      contractList: [],
      stockAmountHash: {},
    };
  },
  computed: {
    baseInfoFields() {
      const _this = this;
      const d = [(val) => !!val || "必选"];
      const arr = [
        {
          label: "合同号",
          key: "contract_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          api: _this.$util.api.contract_select_search,
          "item-text": "text_name",
          initList: _this.contractList,
          cols: 12,
          // required: true,
          handle_data: ({ contracts }) => {
            return contracts.map((item) => ({
              ...item,
              text_name: `${item.uid}-${item.name}`,
            }));
          },
          change: (data, target) => {
            this.changeContract(target);
          },
          rules: d,
          disabled: true,
        },
        {
          label: "分销商",
          type: TEXT_FIELD,
          key: "payee_company_name",
          cols: 12,
          inline: true,
          row: true,
          disabled: true,
        },
        {
          label: "名称",
          type: TEXT_FIELD,
          key: "name",
          cols: 12,
          required: true,
          disabled: true,
          rules: d,
        },
        {
          label: "开始/截止结算日期",
          key: "date_range",
          type: "date_range",
          required: true,
          start_key: "begin_date",
          end_key: "end_date",
          prependIcon: "",
          disabled: true,
          rules: [
            (val) => {
              if (val && val.length < 2) {
                return "需要选择时间段";
              }
              if (val && val.length === 2) {
                return true;
              }
              return "必选";
            },
          ],
        },
        {
          label: "备注",
          type: TEXT_FIELD,
          key: "remark",
          disabled: true,
          cols: 12,
        },
        {
          label: "",
          key: "table",
        },
      ];
      return arr.filter((item) => !item.hide);
    },
    contractPricingInfos() {
      if (!this.currentContractDetail) {
        return [];
      }
      return this.currentContractDetail.contract_product_price_infos;
    },
    table_fields() {
      return [
        {
          text: "合同号",
          value: "contract_id",
          render: () => {
            const contract = this.contractList.find(
              (item) => item.id === this.params.contract_id
            );
            return <div>{contract?.uid}</div>;
          },
        },
        {
          text: "结算类型",
          value: "settlement_name",
          render: (_, row) => {
            const isAdjustment = row.settlement_type === "adjustment";
            if (isAdjustment) {
              return (
                <div>
                  <TextField
                    v-model={row}
                    field={{
                      key: "settlement_name",
                      label: "结算类型",
                      disabled: true,
                    }}
                  />
                </div>
              );
            }
            return <div>{SettlementTypeMap[row.settlement_type]}</div>;
          },
        },
        { text: "销售订单号", value: "sell_order_code" },
        { text: "发货通知号", value: "sell_deliver_order_code" },
        { text: "出入库单据号", value: "in_out_warehouse_order_code" },
        {
          text: "出入库日期",
          value: "amount",
          width: 150,
          render: (_, row) => {
            return (
              <div>
                {row?.link_model?.stock_in_warehouse_order?.input_time && (
                  <div>
                    入库时间
                    {row?.link_model?.stock_in_warehouse_order?.input_time}
                  </div>
                )}
                {row?.link_model?.sell_deliver_order?.send_time && (
                  <div>
                    出库时间{row?.link_model?.sell_deliver_order?.send_time}
                  </div>
                )}
              </div>
            );
          },
        }, // 没找到字段
        { text: "SKU代码", value: "stock_code" },
        { text: "SKU名称", value: "stock_name" },
        {
          text: "单价",
          value: "price",
          width: 150,
          fixed: "right",
          render: (_, row) => {
            if (row.settlement_type === "adjustment") {
              return (
                <div>
                  <NumberField
                    v-model={row}
                    field={{
                      key: "price",
                      label: "单价",
                      required: true,
                      rules: [commonValidateRuleT],
                      disabled: true,
                      change: () => {
                        row.amount = calcAmount(row);
                      },
                    }}
                  />
                </div>
              );
            }
            return <div>{row.price}</div>;
          },
        },
        {
          text: "数量",
          value: "quantity",
          width: 150,
          fixed: "right",
          render: (_, row) => {
            if (row.settlement_type === "adjustment") {
              return (
                <div>
                  <NumberField
                    v-model={row}
                    field={{
                      key: "quantity",
                      label: "数量",
                      required: true,
                      rules: [commonValidateRuleT],
                      disabled: true,
                      change: () => {
                        row.amount = calcAmount(row);
                      },
                    }}
                  />
                </div>
              );
            }
            return <div>{row.quantity}</div>;
          },
        },
        {
          text: "税率",
          value: "tax_rate",
          width: 150,
          fixed: "right",
          render: (_, row) => {
            if (row.settlement_type === "adjustment") {
              return (
                <div>
                  <NumberField
                    v-model={row}
                    field={{
                      key: "tax_rate",
                      label: "税率",
                      required: true,
                      rules: [commonValidateRuleT],
                      disabled: true,
                      change: () => {
                        row.amount = calcAmount(row);
                      },
                    }}
                  />
                </div>
              );
            }
            return <div>{row.tax_rate}</div>;
          },
        },
        {
          text: "总金额",
          value: "amount",
          width: 150,
          fixed: "right",
          render: (_, row) => {
            if (row.settlement_type === "adjustment") {
              return (
                <div>
                  <NumberField
                    v-model={row}
                    field={{
                      key: "amount",
                      label: "总金额",
                      required: true,
                      rules: [commonValidateRuleT],
                      readonly: true,
                      disabled: true,
                    }}
                  />
                </div>
              );
            }
            return <div>{row.amount}</div>;
          },
        },
      ];
    },
    tableProxy() {
      const sumRow = {
        stock_name: "合计",
        amount: 0,
      };
      const totalAmount = this.params.sell_settlement_order_items.reduce(
        (sum, item) => {
          if (item.amount) {
            sum = math.eval(`${sum} + ${item.amount}`).toFixed(2);
          }
          return sum;
        },
        0
      );
      sumRow.amount = totalAmount;
      if (this.params.sell_settlement_order_items.length) {
        return [...this.params.sell_settlement_order_items, sumRow];
      }
      return [...this.params.sell_settlement_order_items];
    },
  },
  watch: {
    currentContract(newVal) {
      if (newVal) {
        this.getContractStockPricing();
      }
    },
    contractPricingInfos: {
      handler(newVal) {
        if (!newVal.length) {
          return;
        }
        const codes = newVal.map((item) => item.stock_code);
        if (codes.length) {
          this.getStockAmount(codes.join(","));
        } else {
          this.$Message.error("合同中没有sku信息");
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    open(params) {
      // 获取详情
      this.dis = true;
      this.loading = true;
      getSellSettlementDetailApi({ id: params.id }).then((res) => {
        this.params = createParams(res);
        this.currentContract = {
          id: res.contract_id,
        };
      });
    },
    submit() {
      this.close();
    },
    close() {
      this.dis = false;
      this.$emit("close");
    },
    changeContract(target) {
      console.log("changeContract", target);
      if (!target) {
        this.currentContract = null;
        return;
      }
      this.currentContract = target;
      this.params.contract_id = target.id;
      this.params.payee_company_name = target.payee_company;
      this.params.payee_company_id = target.payee_company_id;
    },
    addItem() {
      this.params.sell_settlement_order_items.unshift(
        createSellSettlementOrderItem()
      );
    },
    getContractStockPricing() {
      if (!this.currentContract) {
        this.currentContractDetail = null;
        return;
      }
      getContractDetailApi({ id: this.currentContract.id }).then((res) => {
        this.currentContractDetail = res.contract;
        if (!this.contractList.some((item) => item.id === res.contract.id)) {
          this.contractList.push({
            ...res.contract,
            text_name: `${res.contract.uid}-${res.contract.name}`,
          });
        }
      });
    },
    getStockAmount(codes) {
      getThirdPartyMallAvailableStockNumApi({ stock_codes: codes }).then(
        (res) => {
          console.log("res", res);
          if (Array.isArray(res)) {
            res.forEach((item) => {
              this.stockAmountHash[item.sku_code] = item.available_stock_num;
            });
          }
        }
      );
    },
    calcAmount(item) {
      if (!item?.price || !item?.quantity) {
        return 0;
      }
      return item.price * item.quantity;
    },
  },
  render() {
    return (
      <VModel
        fullscreen
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={this.params.id ? "编辑" : "新建"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <VForm
          ref="base"
          v-model={this.params}
          fields={this.baseInfoFields}
          scopedSlots={{
            table: () => {
              return (
                <div>
                  <VTable
                    headers={[...this.table_fields]}
                    desserts={this.tableProxy}
                  />
                </div>
              );
            },
          }}
        />
      </VModel>
    );
  },
};
